import { Avatar } from "@mantine/core"
import { useGetAuthenticatedUser } from "../../app/-components/use-authenticated-user"
import { ChatIcon } from "./ChatIcon"
import { PersonProfilePictureAvatar } from "../../app/-components/person-profile-picture-avatar"
import { ChatDto } from "@/orval/gen/model"
import { useBatchedSimpleUser } from "@/-dataloaders/simple-users"

interface Props {
  chat: ChatDto
}

export function ChatAvatar({ chat }: Props) {
  const { data: authenticatedUser } = useGetAuthenticatedUser()
  const cm =
    chat.chatMembers.find((cm) => cm.userId !== authenticatedUser.userId) ??
    chat.chatMembers[0]
  const { data: user } = useBatchedSimpleUser(cm?.userId ?? 0)

  return chat.chatType === "Direct" ? (
    <PersonProfilePictureAvatar
      personId={user?.personId ?? authenticatedUser.personId ?? 0}
      name={
        user?.userName ??
        authenticatedUser.person?.name ??
        authenticatedUser.userName
      }
    />
  ) : (
    <Avatar>
      <ChatIcon chatType={chat.chatType} />
    </Avatar>
  )
}
